export enum PropertyTabs {
  General,
  Option,
  Constraint,
  Computation
}
